module.exports = __webpack_public_path__ + "static/media/ram.e4beb366.mp3";